import React from "react";
import { FaPeopleGroup } from "react-icons/fa6";
import { FaUserGraduate } from "react-icons/fa";
import { FaPeopleCarryBox } from "react-icons/fa6";

const FokusUtama: React.FC = () => {
  const IconGrup = FaPeopleGroup as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconChild = FaUserGraduate as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconPerson = FaPeopleCarryBox as React.FC<React.SVGProps<SVGSVGElement>>;

  const data = [
    {
      title: "Sosial",
      desc: "Program bantuan sosial untuk mendukung kesejahteraan masyarakat yang membutuhkan.",
      Icon: IconGrup,
    },
    {
      title: "Pendidikan",
      desc: "Inisiatif peningkatan akses dan kualitas pendidikan bagi anak-anak dan pelajar.",
      Icon: IconChild,
    },
    {
      title: "Kemanusiaan",
      desc: "Aksi tanggap darurat dan bantuan kemanusiaan bagi korban bencana dan krisis.",
      Icon: IconPerson,
    },
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Fokus <span className="text-primary2 font-bilbo">Kebaikan</span>
          </h2>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">Fokus program pemberdayaan yang dijalankan untuk menjawab berbagai tantangan sosial di masyarakat.</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.map((item, index) => {
            const Icon = item.Icon;
            return (
              <div
                key={index}
                className="group bg-white border border-gray-200 rounded-2xl p-6
                           transition-all duration-300 hover:-translate-y-2
                           hover:border-primary2 hover:shadow-xl">
                {/* Icon */}
                <div
                  className="w-14 h-14 flex items-center justify-center rounded-xl
                             bg-blue-50 text-primary2  transition
                             group-hover:bg-primary2  group-hover:text-white">
                  <Icon className="w-8 h-8" />
                </div>

                {/* Content */}
                <h3 className="mt-6 text-xl font-bold text-gray-900 group-hover:text-primary2  transition">{item.title}</h3>

                <p className="mt-3 text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FokusUtama;
